import React, { useEffect, useRef, useState } from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { useWindowSize } from 'react-use';
import { SecondaryTemplateDataModel } from '@/types/home';
import MainBenefitsContent from './MainBenefits';
import RelatedTools from './RelatedTools';
import CustomersTalkUsContent from './CustomersTalkUsContent';
import useSearchAccountGuide from '../Dashboard/useSearchAccountGuide';

const FAQContent = dynamic(() => import('./FAQContent'), { ssr: true });
const DownloadInstagramContent = dynamic(() => import('./DownloadInstagramContent'), { ssr: true });
const TopSearchContent = dynamic(() => import('./TopSearch'), { ssr: true });
const GeneralExampDownloadContent = dynamic(() => import('./GeneralExampDownloadContent'), {
  ssr: true,
});
const BestTipsContent = dynamic(() => import('./BestTipsContent'), { ssr: true });
const DownloadStoriesBottomContent = dynamic(() => import('./DownloadStoriesBottomContent'), {
  ssr: true,
});
const AddAccountContent = dynamic(() => import('./AddAccountContent'), { ssr: false });

const InstagramTrackerContent = ({ data }: { data?: any }) => {
  const [contentData, setContentData] = useState<SecondaryTemplateDataModel>(data?.contentData);
  const searchResultRef = useRef<HTMLDivElement>(null);
  const { onSearchAccount, searchAccountLoading, renderPrivateAccountModal, renderAddAccountModal } =
    useSearchAccountGuide();
  const [loading, setLoading] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const { width } = useWindowSize();
  const [inputVisible, setInputVisible] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    setContentData(data?.contentData);
  }, [data]);

  const onValueChanged = (e?: string) => {
    setSearchStr(e ?? '');
  };

  const onSearch = (e?: string) => {
    setSearchStr(e ?? '');
    setOpenModal(true);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <CommonBackContent style={{ minHeight: '100vh' }}>
        <TopSearchContent
          topInfo={contentData?.contentInfo?.hero}
          loading={searchAccountLoading}
          searchVal={searchStr}
          onSearchClick={onSearchAccount}
          onValueChanged={onValueChanged}
          onInputVisibleChanged={(visible) => setInputVisible(visible)}
        />

        <MainBenefitsContent
          data={contentData?.contentInfo['section-1']}
          onTrackClick={() => {
            scrollToTop();
          }}
        />

        <DownloadInstagramContent data={contentData?.contentInfo?.['section-2']} />
        <GeneralExampDownloadContent data={contentData?.contentInfo?.['section-3']} />

        <CustomersTalkUsContent contentInfo={contentData?.contentInfo?.['section-user-reviews']} />

        {contentData?.faqList && (
          <FAQContent faqInfo={contentData?.contentInfo?.['section-faq']} faqList={contentData?.faqList} />
        )}

        <RelatedTools data={contentData?.contentInfo?.['section-tool']} />

        <BestTipsContent
          title={contentData?.contentInfo?.['section-top-blog']?.title}
          blogList={contentData?.topBlogList}
        />
        <BestTipsContent title={contentData?.contentInfo?.['section-blog']?.title} blogList={contentData?.blogList} />
      </CommonBackContent>

      <DownloadStoriesBottomContent
        bottomInfo={contentData?.contentInfo['section-buttom']}
        loading={searchAccountLoading}
        searchVal={searchStr}
        inputVisible={inputVisible}
        onValueChanged={onValueChanged}
        onSearchClick={(e) => {
          onSearchAccount(e);
          if (searchResultRef.current) {
            window.scrollTo({
              top: searchResultRef.current.offsetTop - (width > 900 ? 180 : 150),
            });
          }
        }}
      />

      {renderAddAccountModal()}
      {renderPrivateAccountModal()}
    </>
  );
};

export default InstagramTrackerContent;
